import { render, staticRenderFns } from "./LogisticsPostage.vue?vue&type=template&id=b8848dfc&scoped=true"
import script from "./LogisticsPostage.vue?vue&type=script&lang=js"
export * from "./LogisticsPostage.vue?vue&type=script&lang=js"
import style0 from "./LogisticsPostage.vue?vue&type=style&index=0&id=b8848dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8848dfc",
  null
  
)

export default component.exports